/* TITANOVA theme behaviours (port of the holistichercules.com product page interactions). */
(function () {
  'use strict';
  // Several sections include this script; make sure handlers bind only once.
  if (window.__tnThemeInit) return;
  window.__tnThemeInit = true;
  const $ = (sel, root) => (root || document).querySelector(sel);
  const $$ = (sel, root) => Array.from((root || document).querySelectorAll(sel));
  const mq = (px) => window.matchMedia(`(min-width: ${px}px)`).matches;

  /* ---------- Announcement countdown (to local midnight, ticks every second) ---------- */
  function initCountdown() {
    $$('[data-tn-countdown]').forEach((el) => {
      const h = $('[data-tn-hours]', el);
      const m = $('[data-tn-mins]', el);
      const s = $('[data-tn-secs]', el);
      const pad = (n) => String(n).padStart(2, '0');
      const tick = () => {
        const now = new Date();
        const end = new Date(now);
        end.setHours(24, 0, 0, 0);
        let diff = Math.max(0, Math.floor((end - now) / 1000));
        h.textContent = pad(Math.floor(diff / 3600));
        diff %= 3600;
        m.textContent = pad(Math.floor(diff / 60));
        s.textContent = pad(diff % 60);
      };
      tick();
      setInterval(tick, 1000);
    });
  }

  /* ---------- Sticky header (Dawn "on-scroll-up") ---------- */
  function initStickyHeader() {
    const wrap = $('[data-tn-header]');
    if (!wrap) return;
    const HEADER_HEIGHT = 76;
    let lastY = window.scrollY;
    let ticking = false;
    let isSticky = false;
    let headerTop = wrap.offsetTop;
    const update = () => {
      ticking = false;
      const y = window.scrollY;
      if (!isSticky) headerTop = wrap.offsetTop;
      const bottom = headerTop + HEADER_HEIGHT;
      if (y > lastY && y > bottom) {
        isSticky = true;
        wrap.classList.add('is-sticky', 'is-hidden');
      } else if (y < lastY && y > bottom) {
        isSticky = true;
        wrap.classList.add('is-sticky');
        wrap.classList.remove('is-hidden');
      } else if (y <= headerTop) {
        isSticky = false;
        wrap.classList.remove('is-sticky', 'is-hidden');
      }
      lastY = y;
    };
    window.addEventListener(
      'scroll',
      () => {
        wrap.classList.add('animate');
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      },
      { passive: true }
    );
  }

  /* ---------- Menu drawer ---------- */
  function initMenu() {
    const btn = $('[data-tn-menu-toggle]');
    const drawer = $('[data-tn-menu]');
    const backdrop = $('[data-tn-menu-backdrop]');
    if (!btn || !drawer) return;
    const set = (open) => {
      drawer.classList.toggle('is-open', open);
      backdrop && backdrop.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', String(open));
      document.body.style.overflow = open ? 'hidden' : '';
    };
    btn.addEventListener('click', () => set(!drawer.classList.contains('is-open')));
    $$('[data-tn-menu-close]').forEach((c) => c.addEventListener('click', () => set(false)));
    backdrop && backdrop.addEventListener('click', () => set(false));
    document.addEventListener('keydown', (e) => e.key === 'Escape' && set(false));
  }

  /* ---------- Product gallery (scroll-snap slider + thumbs + mobile dots) ---------- */
  function initGallery() {
    $$('[data-tn-gallery]').forEach((root) => {
      const list = $('[data-tn-gallery-list]', root);
      const slides = $$('[data-tn-gallery-list] > li', root);
      const thumbs = $$('[data-tn-thumb]', root);
      const dots = $$('[data-tn-dot]', root);
      const prev = $('[data-tn-thumb-prev]', root);
      const next = $('[data-tn-thumb-next]', root);
      if (!list || !slides.length) return;
      let active = 0;
      const step = () => slides[0].offsetWidth + (parseFloat(getComputedStyle(list).columnGap) || 0);
      const render = () => {
        thumbs.forEach((t, i) => t.classList.toggle('is-active', i === active));
        dots.forEach((d, i) => d.classList.toggle('is-active', i === active));
        if (prev) prev.disabled = active === 0;
        if (next) next.disabled = active === slides.length - 1;
      };
      const goTo = (i, behavior) => {
        active = Math.max(0, Math.min(slides.length - 1, i));
        list.scrollTo({ left: active * step(), behavior: behavior || 'smooth' });
        const t = thumbs[active];
        t && t.scrollIntoView({ inline: 'nearest', block: 'nearest' });
        render();
      };
      thumbs.forEach((t, i) => t.addEventListener('click', () => goTo(i)));
      dots.forEach((d, i) => d.addEventListener('click', () => goTo(i)));
      prev && prev.addEventListener('click', () => goTo(active - 1));
      next && next.addEventListener('click', () => goTo(active + 1));
      let raf = null;
      list.addEventListener(
        'scroll',
        () => {
          if (raf) return;
          raf = requestAnimationFrame(() => {
            raf = null;
            const s = step();
            if (s > 0) {
              active = Math.max(0, Math.min(slides.length - 1, Math.round(list.scrollLeft / s)));
              render();
            }
          });
        },
        { passive: true }
      );
      if ('ResizeObserver' in window) {
        new ResizeObserver(() => list.scrollTo({ left: active * step(), behavior: 'auto' })).observe(list);
      }
      render();
    });
  }

  /* ---------- Bundle selector → quantity on the Dawn product form ---------- */
  function initBundles() {
    $$('[data-tn-bundles]').forEach((root) => {
      const form = root.closest('[data-tn-product]');
      const qty = form ? $('input[name="quantity"]', form) : null;
      const items = $$('[data-tn-bundle]', root);
      const select = (item) => {
        items.forEach((b) => {
          const on = b === item;
          b.classList.toggle('is-selected', on);
          const input = $('input[type="radio"]', b);
          if (input) input.checked = on;
        });
        if (qty) qty.value = item.dataset.tnQuantity || '1';
      };
      items.forEach((item) => {
        item.addEventListener('click', () => select(item));
        const input = $('input[type="radio"]', item);
        input && input.addEventListener('change', () => select(item));
      });
      const initial = items.find((b) => b.classList.contains('is-selected')) || items[0];
      initial && select(initial);
    });
  }

  /* ---------- Accordions ---------- */
  function initAccordions() {
    $$('[data-tn-acc]').forEach((acc) => {
      const btn = $('button', acc);
      if (!btn) return;
      btn.addEventListener('click', () => {
        const open = !acc.classList.contains('is-open');
        acc.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', String(open));
      });
    });
  }

  /* ---------- Splide-like sliders ---------- */
  function initSliders() {
    $$('[data-tn-slider]').forEach((root) => {
      const track = $('[data-tn-track]', root);
      const list = $('[data-tn-list]', root);
      const slides = $$('[data-tn-list] > li', root);
      const prev = $('[data-tn-prev]', root);
      const next = $('[data-tn-next]', root);
      const dotsWrap = $('[data-tn-dots]', root);
      if (!track || !list || !slides.length) return;
      const cfg = JSON.parse(root.dataset.tnSlider || '{}');
      let index = 0;
      let perView = 1;
      let gap = 12;
      let slideW = 0;
      const compute = () => {
        perView = mq(990) ? cfg.desktop || 3 : mq(750) ? cfg.tablet || 1 : cfg.mobile || 1;
        gap = mq(750) ? 28 : 12;
        slideW = (track.clientWidth - gap * (perView - 1)) / perView;
        slides.forEach((s) => {
          s.style.width = slideW + 'px';
          s.style.marginRight = gap + 'px';
        });
        render();
      };
      const pages = () => Math.max(1, slides.length - perView + 1);
      const render = () => {
        index = Math.max(0, Math.min(pages() - 1, index));
        list.style.transform = `translateX(-${index * (slideW + gap)}px)`;
        if (prev) prev.disabled = index <= 0;
        if (next) next.disabled = index >= pages() - 1;
        if (dotsWrap) {
          const n = pages();
          if (dotsWrap.children.length !== n) {
            dotsWrap.innerHTML = '';
            for (let i = 0; i < n; i++) {
              const li = document.createElement('li');
              const b = document.createElement('button');
              b.type = 'button';
              b.className = 'tn-slider__dot';
              b.setAttribute('aria-label', `Go to slide ${i + 1}`);
              b.addEventListener('click', () => {
                index = i;
                render();
              });
              li.appendChild(b);
              dotsWrap.appendChild(li);
            }
          }
          Array.from(dotsWrap.querySelectorAll('button')).forEach((b, i) => b.classList.toggle('is-active', i === index));
        }
      };
      prev && prev.addEventListener('click', () => { index--; render(); });
      next && next.addEventListener('click', () => { index++; render(); });
      window.addEventListener('resize', compute);
      compute();
    });
  }

  /* ---------- Inline video slides ---------- */
  function initVideos() {
    $$('[data-tn-video]').forEach((box) => {
      const video = $('video', box);
      const play = $('[data-tn-play]', box);
      const timeline = $('[data-tn-timeline]', box);
      if (!video || !play) return;
      play.addEventListener('click', () => {
        if (video.paused) {
          video.play();
          box.classList.add('is-playing');
        } else {
          video.pause();
          box.classList.remove('is-playing');
        }
      });
      video.addEventListener('timeupdate', () => {
        if (timeline && video.duration) timeline.style.setProperty('--completed', (video.currentTime / video.duration) * 100 + '%');
      });
      video.addEventListener('ended', () => box.classList.remove('is-playing'));
    });
  }

  /* ---------- Result rings fill when scrolled into view ---------- */
  function initRings() {
    const roots = $$('[data-tn-rings]');
    if (!roots.length) return;
    const fill = (root) => $$('circle[data-tn-pct]', root).forEach((c) => c.setAttribute('stroke-dasharray', `${c.dataset.tnPct} 100`));
    if (!('IntersectionObserver' in window)) return roots.forEach(fill);
    const io = new IntersectionObserver(
      (entries) => entries.forEach((e) => { if (e.isIntersecting) { fill(e.target); io.unobserve(e.target); } }),
      { threshold: 0.3 }
    );
    roots.forEach((r) => io.observe(r));
  }

  const init = () => {
    initCountdown();
    initStickyHeader();
    initMenu();
    initGallery();
    initBundles();
    initAccordions();
    initSliders();
    initVideos();
    initRings();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // Re-init when the theme editor re-renders a section.
  document.addEventListener('shopify:section:load', init);
})();
